import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="siteFooter">
      <div className="container footerGrid">
        <div>
          <div className="footerBrand">
            <span className="logoMark smallMark" aria-hidden="true">S</span>
            <div>
              <div className="footerTitle">Seasons Flavours Fragrances</div>
              <div className="small">Handcrafted flavours & fragrance experiences for every season.</div>
            </div>
          </div>
          <div className="small footerNote">© {year} Seasons Flavours Fragrances. All rights reserved.</div>
        </div>

        <div className="footerCol">
          <div className="footerHead">Explore</div>
          <a className="footerLink" href="#about">About Us</a>
          <a className="footerLink" href="#products">Products</a>
          <a className="footerLink" href="#reviews">Clients Reviews</a>
          <a className="footerLink" href="#contact">Contact</a>
        </div>

        <div className="footerCol">
          <div className="footerHead">Business</div>
          <div className="small">
          <span className="footerLink" >  Name: Seasons Flavours & Fragrances</span>
          <span className="footerLink"> Email:admin@seasonsflavoursfragrance.shop</span>
          <span className="footerLink">  Address: ground 30, g, Nayandahalli Pantharapalaya, Mysore Road, Bengaluru, Bangluru (Bangalore) Urban, Karnatka 560039 </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
